import Vue from 'vue'
import Router from 'vue-router'
import DrillList from '@/components/DrillList.vue'
import Drill from '@/components/Drill.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
	{
		path: '/',
		name: 'list',
		component: DrillList
	},
	{
		path: '/:drill',
		name: 'drill',
		component: Drill
	}
  ]
})
